import httpClient from '@/libs/http-client'
import { encrypt } from '@/libs/utils'

export function signIn (params) {
  const url = '/new_user/login'
  params.password = encrypt(params.password, params.username)

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function signUp (params) {
  const url = '/samsung/user/signup'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function refreshToken (token) {
  const url = '/auth/refresh'
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }

  return httpClient.post(url, {}, config).then(response => {
    return response.data.result
  })
}

export function getUserInfo () {
  const url = '/samsung/user/get_info'

  return httpClient.post(url).then(response => {
    let result = response.data.result
    result.isGmc = false
    if (['admin', 'samsung_gmc'].includes(result.userId)) {
      result.isGmc = true
    }
    if (result.originalSiteCodeList) {
      result.originalSiteCodeList.sort()
    }
    if (result.etcSiteCodeList) {
      result.etcSiteCodeList.sort()
    }
    if (result.siteCodeList) {
      result.siteCodeList.sort()
    }
    if (result.remainPv) {
      result.creditEmpty = false
    }
    return result
  })
}

export function findPassword (params) {
  const url = '/samsung/user/find_password'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function resetPassword (params) {
  const url = '/user/reset_password'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkDupId (params) {
  const url = '/samsung/user/check_dup_id'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function checkDupEmail (params) {
  const url = '/samsung/user/check_dup_email'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function modify (params, userId = null) {
  const url = '/samsung/user/modify'

  if (userId) {
    if (params.userPw) {
      params.userPw = encrypt(params.userPw, userId)
    }
    if (params.userPw) {
      params.userNewPw = encrypt(params.userNewPw, userId)
    }
  }

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getPvStatus (startDate, endDate) {
  const url = '/samsung/user/get_pv_status'

  return httpClient.post(url, { startDate, endDate }).then(response => {
    return response.data.result
  })
}

export function deactivateInfo () {
  const url = '/samsung/user/deactivate_info'

  return httpClient.get(url).then(response => {
    return response.data.result
  })
}

export function deactivate (params) {
  const url = '/samsung/user/deactivate'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function myInfoLogin (username, password) {
  const url = '/user/myinfo_login'
  password = encrypt(password, username)

  return httpClient.post(url, { password }).then(response => {
    return response.data.result
  })
}

export function planHistory (startDate, endDate) {
  const url = '/plan_history/list'

  return httpClient.post(url, { startDate, endDate }).then(response => {
    return response.data.result
  })
}

export function insertLoginHistory (params) {
  const url = '/new_user/insert_login_history'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function userList (params) {
  const url = '/samsung/user/list'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function userApprove (params) {
  const url = '/samsung/user/approve'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function userInfo (params) {
  const url = '/samsung/user/info'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function updateUserInfo (params) {
  const url = '/samsung/user/update'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}
